/*
 * Authors: mariushirjanu
 * Created: 07/12/2022
 */

import * as _ from 'underscore';
import { util } from '../../../../shared/util';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { StateService, Transition, TransitionService, UiOnParamsChanged } from '@uirouter/angular';
import { Subscription } from 'rxjs';

import { BreadcrumbService, IBreadcrumb } from '../../../../shared/breadcrumbs/breadcrumb.service';
import { ICatalogCategory, ICatalogProduct, IProductSearchList, OrderCatalogDataService } from '../order-catalog-data.service';
import { CatalogStateService } from '../catalog-state.service';
import { ICatalogLayout, OrderCatalogService } from '../order-catalog.service';
import { MaxWidth, ResponsiveService } from '../../../../shared/responsive/responsive.service';
import { BreakpointsService } from '../../../../shared/services/breakpoints.service';
import { ScrollService } from '../../../../shared/scroll/scroll.service';
import { AuthService } from '../../../../shared/services/auth/auth.service';
import { IPunchout, PunchoutCatalogService } from '../../entry/catalog/punchout-catalog.service';
import { BuyingGuideModel } from '../guide/buying-guide.model';
import { BodyClassService } from '../../../../shared/services/body-class.service';
import { DEFAULT_STOCK_ORDER_TYPE, OrderEntryInfoService } from '../../entry/order-info/order-entry-info.service';
import { GaWizardService } from '../../../../shared/wizard/ga-wizard.service';
import { WIZARD_ORDER } from '../../../../shared/app-wizards';
import { GaWizard } from '../../../../shared/wizard/ga-wizard';
import { CatalogCategoryType, CatalogOverviewService } from './catalog-overview.service';
import { CatalogOverviewFiltersUtilService } from './catalog-overview-filters-util.service';
import { GaEventService, IGAEvent } from '../../../../shared/services/ga-event.service';
import { EVENT_ORDER_CART_CURRENCY_CHANGED } from '../../../../shared/app-events';
import { INamedStringObject, INumericObject, IObject } from '../../../../../type_definitions/datatypes';
import { trackByFunction } from '../../../../shared/formly/ga-formly.util';

const CATALOG_PUNCHOUT_ACTIVE:string = 'punchout-catalog-active';

export interface ICatalogSearchParam {
  pmin:number;
  pmax:number;
  instock:boolean;
  sortCurrent:string;
  num:number;
  page:number;
  terms:string;
  type:string;
  selectedCategoryName:string;
  buyingGuideCode:string;
  selectedFilters:IObject;
  onlyFavourites:boolean;
}

@Component({
  selector: 'order-catalog-overview',
  template: `
    <div class="catalog-overview">
      <div class="top-container">
        <div *ngIf="compatibleProductName && !(isOnlyExternal || categoriesIsLoading)">
          <h3 class="compatible-title">
            <a [uiSref]="detailState()" [uiParams]="{ product: compatibleProductId }">{{compatibleProductName}}</a>&nbsp;<span translate>CATALOG.COMPATIBLE_PRODUCTS</span>
          </h3>
        </div>
      </div>

      <!-- Hide catalog when emptyCatalog is true or there is no available categories from server, or only 1 external category -->
      <catalog-categories *ngIf="!buyingGuideId" [hidden]="emptyCatalog || !categories?.length || hideCategoriesButton || categoriesIsLoading" [categories]="categories" [selectedCategoryName]="searchParams.selectedCategoryName" [categoryCounts]="categoryCounts" [punchoutIsLoading]="punchoutIsLoading"
        (onSelectCategory)="setCategory($event)"></catalog-categories>

      <!-- It will only show CTO button when more than 1, or when it has normal categories and CTO button, it should not be displayed when catalog only has 1 CTO button and no normal categories -->
      <div class="accesstype-button-category clearfix" *ngIf="(categories?.length && accessTypeButtonCategories?.length) || accessTypeButtonCategories?.length > 1">
        <div class="btn-group">
          <button class="btn btn-primary" *ngFor="let externalButton of accessTypeButtonCategories; trackBy: trackByFunction" [ngClass]="{active: externalButton.name === searchParams.selectedCategoryName}" (click)="setCategory(externalButton)">{{externalButton.description}}
            <i *ngIf="punchoutIsLoading && externalButton.name === searchParams.selectedCategoryName" class="fa fa-spinner fa-spin activity-indicator margin-left-sm"></i>
          </button>
        </div>
      </div>
      <div *ngIf="!punchoutCatalog" class="internal-catalog">
        <catalog-controls *ngIf="!(isOnlyExternal || categoriesIsLoading)" [searchParams]="searchParams" [selectedLayout]="selectedLayout" [searching]="searching" (onSearch)="search()" (onModifySearch)="modifySearch()" (onSelectLayout)="selectLayout($event)"></catalog-controls>

        <div class="catalog-filters" [ngClass]="{'filters-visible': !smallScreen && showFilter}">
          <catalog-filters *ngIf="!(isOnlyExternal || categoriesIsLoading)" [searchParams]="searchParams" [selectedLayout]="selectedLayout" [filterCounts]="filterCounts" (onModifySearch)="modifySearch()" (onFiltersVisibility)="updateFiltersVisibility($event)">
            <pagination *ngIf="numPages > 1" class="pager pager-top float-end" [maxSize]="4" [totalItems]="numPages" [itemsPerPage]="1" [(ngModel)]="currentPage" previousText="&lsaquo;" nextText="&rsaquo;" [rotate]="false"></pagination>
          </catalog-filters>

          <div class="content-wrap" [ngClass]="{'col-md-12': smallScreen || !showFilter}">
            <catalog-content [searchParams]="searchParams" [selectedLayout]="selectedLayout" [searching]="categoriesIsLoading || searching"></catalog-content>
            <pagination *ngIf="numPages > 1" class="pager pager-bottom float-end" [maxSize]="4" [totalItems]="numPages" [itemsPerPage]="1" [(ngModel)]="currentPage" previousText="&lsaquo;" nextText="&rsaquo;" [rotate]="false"></pagination>
          </div>

        </div>
      </div>

      <!-- space when catalog contains single button category or only external categories -->
      <div *ngIf="accessTypeButtonCategories?.length === 1 || isOnlyExternal" class="margin-top-sm is-only-external"></div>

      <div *ngIf="punchoutCatalog" class="punchout-catalog" fillHeight="5px;.is-only-external;.propose-alternatives-warning;.navbar-wizard;.catalog-title;.categories;.top-container;.accesstype-button-category;.ui-layout-north;.ui-layout-resizer-north" fillHeightMethod="timeout">
        <h2 *ngIf="loadingInfo">
          <activity-indicator></activity-indicator>
          <span translate>CATALOG.PUNCHOUT_LOADING_MESSAGE</span>
        </h2>
        <punchout-catalog [protocol]="punchoutProtocol" [url]="punchoutPostUrl" [message]="punchoutMessage" (onLoading)="onLoading($event)" (onPunchoutTransfer)="onPunchoutTransfer($event)"></punchout-catalog>
      </div>

    </div>
  `
})
export class OrderCatalogOverviewComponent implements OnInit, OnDestroy, UiOnParamsChanged {
  public showProposeAlternatives:boolean;
  public categoriesIsLoading:boolean;
  public compatibleProductName:string;
  public detailState:Function;
  public emptyCatalog:boolean;
  public categories:ICatalogCategory[];
  public accessTypeButtonCategories:ICatalogCategory[];
  public hideCategoriesButton:boolean;
  public buyingGuideId:number;
  public toggleFavourite:Function;
  public searchParams:ICatalogSearchParam;
  public selectedLayout:ICatalogLayout;
  public stockOrderType:string;
  public punchoutIsLoading:boolean;
  public punchoutProtocol:string;
  public punchoutPostUrl:string;
  public punchoutMessage:string;
  public showLeadTime:boolean;
  public defaultSearch:boolean;
  public punchoutCatalog:boolean;
  public filterCounts:IObject;
  public showFilter:boolean;
  public numPages:number;
  public searching:boolean;
  public loadingInfo:boolean;
  public compatibleProductId:number;

  private eventHandler:Subscription;
  private readonly possibleLayouts:ICatalogLayout[];
  private readonly defaultLayout:ICatalogLayout;
  private readonly blockLayout:ICatalogLayout;
  private sortOptions:INamedStringObject[];
  public categoryCounts:INumericObject;
  private selectedCategory?:ICatalogCategory;
  public smallScreen:boolean;
  private xSmallScreen:boolean;
  private products:ICatalogProduct[];
  private wizard:GaWizard;
  private onStateStartHook:Function;
  public trackByFunction:Function = trackByFunction;

  constructor(
    private stateService:StateService,
    private breadcrumbService:BreadcrumbService,
    private gaEventService:GaEventService,
    private orderCatalogDataService:OrderCatalogDataService,
    private catalogStateService:CatalogStateService,
    private orderCatalogService:OrderCatalogService,
    private catalogOverviewFiltersUtilService:CatalogOverviewFiltersUtilService,
    private catalogOverviewService:CatalogOverviewService,
    private responsiveService:ResponsiveService,
    private breakpointsService: BreakpointsService,
    private scrollService:ScrollService,
    private wizardService:GaWizardService,
    private authService:AuthService,
    private punchoutCatalogService:PunchoutCatalogService,
    private buyingGuideModel:BuyingGuideModel,
    private bodyClassService:BodyClassService,
    private orderEntryInfoService:OrderEntryInfoService,
    private transitionService:TransitionService
  ) {
    this.wizard = this.wizardService.getInstance(WIZARD_ORDER);
    this.possibleLayouts = this.catalogOverviewService.possibleLayouts;
    this.defaultLayout = this.possibleLayouts[0];
    this.blockLayout = this.defaultLayout;

    this.sortOptions = this.catalogOverviewService.sortOptions;

    if (!this.orderCatalogService.webshopId) {
      return;
    }
  }

  public ngOnInit():void {
    const guide:string = this.stateService.params.guide;
    if (guide) {
      this.buyingGuideModel.searchCode(guide);
    }
    this.buyingGuideId = this.catalogStateService.buyingGuideId;

    //load from cache
    this.categoryCounts = <any>this.catalogOverviewService.categoryCounts || <any>{};
    this.filterCounts = <any>this.catalogOverviewService.filterCounts || <any>{};
    this.numPages = <number>this.catalogOverviewService.numPages || 0;
    this.selectedCategory = this.catalogOverviewService.selectedCategory || <any>{};

    this.smallScreen = undefined;
    this.xSmallScreen = undefined;

    this.searching = false;

    this.compatibleProductName = undefined;
    this.compatibleProductId = undefined;

    this.searchParams = <any>{};

    //read all params from the $stateParams
    this.compatibleProductId = this.stateService.params.compat && Number(this.stateService.params.compat);
    if (this.compatibleProductId) {
      this.buyingGuideModel.showingAll(false);
    }

    //layout -> defaults to 'block'
    this.selectedLayout = _.findWhere(this.possibleLayouts, { name: this.stateService.params.layout || this.orderCatalogService.layout }) || this.defaultLayout;

    //pmin, pmax
    this.searchParams.pmin = this.stateService.params.pmin && Number(this.stateService.params.pmin);
    if (isNaN(this.searchParams.pmin)) {
      this.searchParams.pmin = undefined;
    }
    this.searchParams.pmax = this.stateService.params.pmax;
    if (isNaN(this.searchParams.pmax)) {
      this.searchParams.pmax = undefined;
    }

    //sort
    this.searchParams.sortCurrent = this.stateService.params.sort || this.orderCatalogService.sort || this.sortOptions[ 2 ].id;

    //num
    this.searchParams.num = this.stateService.params.num && Number(this.stateService.params.num);
    if (isNaN(this.searchParams.num)) {
      this.searchParams.num = this.selectedLayout.productsPerPage.current;
    }

    //page
    this.searchParams.page = this.stateService.params.page && Number(this.stateService.params.page);
    if (isNaN(this.searchParams.page)) {
      this.searchParams.page = 1;
    }

    //terms
    this.searchParams.terms = this.stateService.params.terms;

    // cat type
    this.searchParams.type = this.stateService.params.type;

    //cat
    this.searchParams.selectedCategoryName = this.stateService.params.cat || 'All';

    //buyingGuideCode
    this.searchParams.buyingGuideCode = this.stateService.params.guide;

    //filters
    this.searchParams.selectedFilters = this.catalogOverviewFiltersUtilService.paramToSelection(this.stateService.params.filters);

    //instock
    this.searchParams.instock = this.stateService.params.instock ? util.stringToBoolean(this.stateService.params.instock) : this.orderCatalogService.showOnlyInStockItems; // 'true' to true, 'false' to false, undefined to undefined

    //fav
    this.searchParams.onlyFavourites = util.stringToBoolean(this.stateService.params.fav);

    // stock order type
    this.stockOrderType = this.stateService.params.stockOrderType || this.orderCatalogService.stockOrderType || this.orderEntryInfoService.stockOrderType?.id || DEFAULT_STOCK_ORDER_TYPE;

    this.defaultSearch = util.isNullOrUndefined(this.stateService.params.fav) && util.isNullOrUndefined(this.stateService.params.instock) && util.isNullOrUndefined(this.stateService.params.cat) && util.isNullOrUndefined(this.stateService.params.terms) && util.isNullOrUndefined(this.stateService.params.pmin) && util.isNullOrUndefined(this.stateService.params.pmax) && util.isNullOrUndefined(this.stateService.params.filters);

    // public methods
    this.toggleFavourite = this.orderCatalogDataService.toggleFavourite;

    this.detailState = () => this.catalogStateService.detailState;

    this.accessTypeButtonCategories = _.clone(this.orderCatalogService.accessTypeButtonCategory);

    // triggered by the component punchout-catalog: notify when punchout iframe is loading
    this.punchoutIsLoading = false;

    // triggered by the component punchout-catalog when the cart is received
    this.loadingInfo = false;

    this.activate();
    this.listen();
  }

  private listen():void {
    this.eventHandler = this.gaEventService.events.subscribe((event:IGAEvent) => {
      switch(event.name){
        case EVENT_ORDER_CART_CURRENCY_CHANGED:
          this.orderCatalogService.currency = event.data;
          this.loadProducts(true);
          break;
      }
    });

    this.onStateStartHook = this.transitionService.onStart({}, (transition:Transition) => {
      this.storeScrollPosition(transition);
      this.keepOrClearCache(transition);
    });
  }

  public onPunchoutTransfer = (punchoutData:IPunchout):Promise<void> => {
    this.loadingInfo = true;
    return this.punchoutCatalogService.punchoutToCart(punchoutData)
      .then(() => {

        const punchoutHandler = this.punchoutCatalogService.punchoutToCartHandler();
        if (punchoutHandler) {
          // add timeout here to let angular fully digest the cart data
          setTimeout(() => {
            punchoutHandler()
              .finally(() => {
                this.loadingInfo = false;
              });
          });
        } else {
          this.loadingInfo = false;
          this.wizard.selectStep(this.wizard.activeStepIndex + 1);
        }
      })
      .catch(() => {
        // if loading prices fail we still need to hide the loading
        this.loadingInfo = false;
      });
  };

  public onLoading = (loading:boolean):void => {
    this.punchoutIsLoading = loading;
  };

  private activate():void {
    this.sizeUpdate();

    if (!this.punchoutCatalog) {
      this.orderCatalogService.isStarted()
        .then(() => {
          this.categoriesIsLoading = true;
          // has to be called after catalog is started, otherwise baseParams are not set
          this.initBreadcrumbs();
          return this.orderCatalogService.categoriesPromise;
        }) // wait for categories to load before loading the products
        .then((categories:ICatalogCategory[]) => {
          this.onCategoriesChanged(categories);
          // when this component is activated, we have to force a product search
          // the load products method itself will figure out if this is applicable or not
          // order-catalog-data.service will prevent duplicate searches via its cache
          this.loadProducts(true);
        })
        .catch(util.noop)
        .finally(() => {
          this.categoriesIsLoading = false;
        });
    }
  }

  private initBreadcrumbs():void {
    let breadcrumbs:IBreadcrumb[];

    if (!this.compatibleProductId) {
      breadcrumbs = [
        this.breadcrumbService.create('Products',
          this.catalogStateService.overviewState,
          {
            ...this.stateService.params,
            part: undefined
          })
      ];
      breadcrumbs.splice(1, breadcrumbs.length - 1);
    } else {
      breadcrumbs = this.breadcrumbService.breadcrumbs;
      if (!breadcrumbs[ 0 ] || breadcrumbs[ 0 ].state !== this.catalogStateService.overviewState) { //if there is one, keep it
        breadcrumbs[ 0 ] = this.breadcrumbService.create('Products',
          this.catalogStateService.overviewState,
          this.catalogStateService.createStateParams({}));
      }
      if (!breadcrumbs[ 1 ] || breadcrumbs[ 1 ].state !== this.catalogStateService.detailState) { //if there is one, keep it
        breadcrumbs[ 1 ] = this.breadcrumbService.create(`Product ${this.compatibleProductId}`,
          this.catalogStateService.detailState,
          this.catalogStateService.createStateParams({ product: this.compatibleProductId }));
      }

      //load details of compatible product id
      this.orderCatalogDataService.product(this.compatibleProductId, undefined, undefined, true)
        .then((product:ICatalogProduct) => {
          this.compatibleProductName = product.shortDescription;
          breadcrumbs[ 1 ] = this.breadcrumbService.create(product.shortDescription,
            this.catalogStateService.detailState,
            this.catalogStateService.createStateParams({ product: product.id }));
        })
        .catch(util.noop);

      breadcrumbs[ 2 ] = this.breadcrumbService.create('Compatible products',
        this.catalogStateService.overviewState,
        this.catalogStateService.createStateParams({ compat: this.compatibleProductId }));
      breadcrumbs.splice(3, breadcrumbs.length - 3);
    }
    this.breadcrumbService.breadcrumbs = breadcrumbs;
  }

  private sizeUpdate():void {
    const currentBP:string = this.breakpointsService.current();
    this.smallScreen = (currentBP === 'xs' || currentBP === 'sm');
    this.xSmallScreen = currentBP === 'xs';

    if (this.orderCatalogService.autoSwitchLayout) {
      // check breakpoints

      if (this.xSmallScreen) {
        this.selectedLayout = this.blockLayout;
      }
    }

    this.updateWidthFromLayout();
  }

  private updateWidthFromLayout():void {
    // if catalog punch out is active don't change layout width
    this.responsiveService.width = !this.punchoutCatalog? (this.selectedLayout.width || MaxWidth.MD) : MaxWidth.LG;
  }

  private onCategoriesChanged(categories:ICatalogCategory[]):void {
    this.categories = _.clone(this.orderCatalogService.filteredCategories);
    this.accessTypeButtonCategories = _.clone(this.orderCatalogService.accessTypeButtonCategory);

    if (this.selectedCategory?.name) {
      this.updatePunchoutCatalog(this.selectedCategory);
    } else if (!this.buyingGuideId) {
      this.showProposeAlternatives = this.orderCatalogService.showProposeAlternatives;

      this.hideCategoriesButton = (this.isOnlyExternal && categories.length === 1);
      this.orderCatalogService.singleExternalCategory = this.hideCategoriesButton;

      if (categories?.length > 0) {
        this.selectedCategory = _.find(categories, { name: this.searchParams.selectedCategoryName }) || categories[ 0 ];
        if(this.selectedCategory && this.searchParams.type !== CatalogCategoryType.EXTERNAL) {
          this.searchParams.selectedCategoryName = this.selectedCategory.name;
          if(this.searchParams.type !== CatalogCategoryType.INTERNAL){
            this.updatePunchoutCatalog(this.selectedCategory);
          }
        } else {
          const allCategory:ICatalogCategory = _.find(categories, { name: 'All' }) || categories[ 0 ];
          this.setCategory(allCategory);
        }
      }
    }
  }

  private updatePunchoutCatalog(category:ICatalogCategory):void {
    // update width based on selected layout
    this.updateWidthFromLayout();

    if (category?.type === CatalogCategoryType.EXTERNAL) {
      this.responsiveService.width = MaxWidth.LG;
      this.bodyClassService.add(CATALOG_PUNCHOUT_ACTIVE);

      // replace token placeholder from HOOK_URL
      category.message = category.message
        .replace('{TOKEN}', this.authService.getToken());

      this.punchoutProtocol = category.punchoutProtocol;
      this.punchoutPostUrl = category.postUrl;
      this.punchoutMessage = category.message;

      this.punchoutCatalog = true;
      this.reloadState();
    } else {
      this.clearPunchoutCatalog();
    }

    this.categoriesIsLoading = false;
  }

  private clearPunchoutCatalog():void {
    this.bodyClassService.remove(CATALOG_PUNCHOUT_ACTIVE);
    this.punchoutProtocol = undefined;
    this.punchoutPostUrl = undefined;
    this.punchoutMessage = undefined;

    this.punchoutCatalog = false;
  }

  private storeScrollPosition(transition:Transition):void {
    if (transition.to().name === this.catalogStateService.detailState) {
      this.orderCatalogService.scrollPosition = this.scrollService.scrollTop();
      this.orderCatalogService.scrollTarget = `catalog-${transition.params('to').product}`;
    } else {
      this.orderCatalogService.scrollPosition = undefined;
      this.orderCatalogService.scrollTarget = undefined;
    }
  }

  private keepOrClearCache(transition:Transition):void {
    if (transition.to().name !== transition.from().name) {
      this.catalogOverviewService.clear();
    }
  }

  private newStateParams():ICatalogSearchParam {
    //do not add params that are the default
    const sp:any = {};
    sp.compat = this.compatibleProductId;
    sp.layout = this.selectedLayout === (this.orderCatalogService.layout || this.defaultLayout) ? undefined : this.selectedLayout.name;
    sp.pmin = this.searchParams.pmin;
    sp.pmax = this.searchParams.pmax;
    sp.sort = this.searchParams.sortCurrent === (this.orderCatalogService.sort || this.sortOptions[ 2 ].id)? undefined : this.searchParams.sortCurrent;
    sp.num = this.searchParams.num === this.selectedLayout.productsPerPage.current? undefined : this.searchParams.num;
    sp.page = this.searchParams.page === 1? undefined : this.searchParams.page;
    sp.terms = this.searchParams.terms;
    sp.guide = this.searchParams.buyingGuideCode? this.searchParams.buyingGuideCode : undefined;
    sp.cat = this.searchParams.selectedCategoryName === 'All'? undefined : this.searchParams.selectedCategoryName;
    sp.instock = !!this.searchParams.instock;
    sp.filters = this.catalogOverviewFiltersUtilService.selectionToParam(this.searchParams.selectedFilters);
    sp.fav = this.searchParams.onlyFavourites? true : undefined;
    sp.type = this.searchParams.type;
    return sp;
  }

  private statesMatch(sp:IObject, np:IObject) {
    const oldUrl:string = this.stateService.href(this.stateService.current.name, sp);
    const newUrl:string = this.stateService.href(this.stateService.current.name, np);
    return oldUrl === newUrl;
  }

  private reloadState():void {
    const newParams:ICatalogSearchParam = this.newStateParams();
    const eq:boolean = this.statesMatch(this.stateService.params, newParams);

    this.stateService.go(this.stateService.current.name, newParams);

    if (eq) { //this means we won't have had a real state change -> trigger a load
      this.loadProducts(true);
    }
  }

  // called when search button is pressed
  public search():void {
    this.searchParams.selectedCategoryName = 'All';
    this.searchParams.selectedFilters = {};
    this.searchParams.pmin = undefined;
    this.searchParams.pmax = undefined;
    this.searchParams.instock = false;
    this.searchParams.page = 1;

    this.reloadState(); //reload so it triggers a search when the search button is clicked
  }

  private categorySearch():void {
    this.searchParams.selectedFilters = {};
    this.searchParams.buyingGuideCode = undefined;
    this.searchParams.pmin = undefined;
    this.searchParams.pmax = undefined;
    this.searchParams.instock = false;
    this.searchParams.page = 1;

    this.reloadState();
  }

  //applies to price filter, property filters, list order, items per page, selected page
  public modifySearch():void {
    this.reloadState();
  }

  public updateFiltersVisibility(showFilter:boolean):void {
    this.showFilter = showFilter;
  }

  private isLayoutSwitch():boolean {
    const oldParams:IObject = _.clone(this.catalogOverviewService.state.params);
    const newParams:IObject = _.clone(this.stateService.params);

    oldParams.num = Number(oldParams.num);
    if (isNaN(oldParams.num)) {
      oldParams.num = (oldParams.layout? _.findWhere(this.possibleLayouts, { name: oldParams.layout }) : this.defaultLayout).productsPerPage.current;
    }

    newParams.num = Number(newParams.num);
    if (isNaN(newParams.num)) {
      newParams.num = (newParams.layout? _.findWhere(this.possibleLayouts, { name: newParams.layout }) : this.defaultLayout).productsPerPage.current;
    }

    oldParams.layout = undefined;
    newParams.layout = undefined;

    return _.isEqual(oldParams, newParams);
  }

  private loadProducts(force?:boolean):void {
    // never load products for category = EXTERNAL
    if(this.selectedCategory.type !== CatalogCategoryType.EXTERNAL) {

      //compare the current params with the cached ones to decide if we need to search or load from cache
      if ((!force && this.catalogOverviewService.state?.name === this.stateService.current.name && this.isLayoutSwitch())) {
        this.products = this.catalogOverviewService.products;
        this.showLeadTime = !!_.find(this.products, (product:any) => !!product.leadTime?.days);
      } else if (this.orderCatalogService.categories?.length) {
        // arguments: productId, terms, favourites, category, buying guide code, filters, num, page, pmin, pmax
        this.searching = true;
        this.orderCatalogDataService.search(
          this.compatibleProductId,
          this.searchParams.terms,
          this.searchParams.onlyFavourites,
          this.searchParams.selectedCategoryName,
          this.searchParams.buyingGuideCode,
          this.searchParams.selectedFilters,
          this.searchParams.num,
          this.searchParams.page,
          this.searchParams.pmin,
          this.searchParams.pmax,
          this.searchParams.instock,
          this.searchParams.sortCurrent,
          this.stockOrderType)
          .then((data:IProductSearchList) => {
            this.categoryCounts = data.categories || {};
            this.filterCounts = data.filters || {};
            this.products = this.formatProductsData(<ICatalogProduct[]>data.products);
            this.showLeadTime = !!_.find(data.products, (product:any) => !!product.leadTime?.days);
            this.numPages = data.pages.total;

            this.emptyCatalog = !this.numPages && this.defaultSearch;
            this.searchParams.page = data.pages.current;

            //store in cache, so that we can display something while we load the next results
            this.catalogOverviewService.categoryCounts = this.categoryCounts;
            this.catalogOverviewService.filterCounts = this.filterCounts;
            this.catalogOverviewService.numPages = this.numPages;
            this.catalogOverviewService.products = this.products;
          })
          .catch(util.noop)
          .finally(() => {
            setTimeout(() => {
              this.searching = false; // has to be under setTimeout, so that child components have time to see the change when a search is fetched from cache
              if (this.orderCatalogService.scrollPosition) {
                this.scrollService.scrollTop(this.orderCatalogService.scrollPosition);
                this.scrollService.scrollTo(this.orderCatalogService.scrollTarget); //make sure it is visible, even if the layout has changed

                this.orderCatalogService.scrollPosition = undefined;
                this.orderCatalogService.scrollTarget = undefined;
              }
            });
          });
      }

      //store the overview state in the cache
      this.catalogOverviewService.state = {
        name: this.stateService.current.name,
        params: _.clone(this.stateService.params)
      };
    }
  }

  public setCategory(category:ICatalogCategory):void {
    this.searchParams.selectedCategoryName = category.name;
    this.searchParams.type = category.type;
    this.selectedCategory = category;

    //store in cache, so that we can display something while we load the next results
    this.catalogOverviewService.selectedCategory = this.selectedCategory;

    if (category?.type === CatalogCategoryType.INTERNAL) {
      this.categorySearch();
      this.clearPunchoutCatalog();
    } else {
      this.updatePunchoutCatalog(this.selectedCategory);
    }

  }

  private formatProductsData(products:ICatalogProduct[]) {
    _.forEach(products, (product:any) => {
      //add one small and one medium image
      if (product.images?.length) {
        product.image = {
          title: product.images[ 0 ].title,
          tiny: this.orderCatalogService.imageURL(product.images[ 0 ], 'tiny'),
          small: this.orderCatalogService.imageURL(product.images[ 0 ], 'small'),
          medium: this.orderCatalogService.imageURL(product.images[ 0 ], 'medium')
        };
      }
    });
    return products;
  }
  
  public selectLayout(layout:ICatalogLayout):void {
    this.selectedLayout = layout;
    //adjust the number of items per page if necessary
    if (_.indexOf(layout.productsPerPage.options, this.searchParams.num) < 0) { //the selected layout doesn't have that number of items per page
      this.searchParams.num = layout.productsPerPage.current;
    }
    this.reloadState();
  }

  public get currentPage():number {
    return this.searchParams.page;
  }

  public set currentPage(currentPage:number) {
    this.searchParams.page = currentPage;
    this.modifySearch();
  }

  // to hide catalog title and top container element class when only external catalog available
  public get isOnlyExternal():boolean {
    return this.orderCatalogService.isOnlyExternal;
  }

  public uiOnParamsChanged = ():void => {
    this.loadProducts(true);
  };

  public ngOnDestroy():void {
    this.eventHandler?.unsubscribe();
    this.bodyClassService.remove(CATALOG_PUNCHOUT_ACTIVE);
    this.onStateStartHook();
    this.responsiveService.width = MaxWidth.SM;
  }
}